import { render, staticRenderFns } from "./VIPOrder.vue?vue&type=template&id=98e380ca&scoped=true"
import script from "./VIPOrder.vue?vue&type=script&lang=js"
export * from "./VIPOrder.vue?vue&type=script&lang=js"
import style0 from "./VIPOrder.vue?vue&type=style&index=0&id=98e380ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e380ca",
  null
  
)

export default component.exports